export default function PaysConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('pays');
}

PaysConfiguration.$inject = ['$translatePartialLoaderProvider'];
